var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"header-content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"header-margin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }